/*
 * @file 原名shareCard， 原文件位置 /common/components/shareCard/shareCard
 * @author duanjun
 * @date
 */

import React, { Component } from 'react';
import { components } from 'common';
const { Loading, If, PreImg } = components;

import './sharePicCard.scss';

interface IProps {
    shareImage: string;
}

export default class SharePicCard extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        const shareImage = this.props.shareImage;
        return (
            <div className="share-card-container">
                <If condition={!!shareImage}>
                    <div className="image-wrap">
                        <PreImg>
                            <img src={shareImage} />
                        </PreImg>
                    </div>
                </If>

                <If condition={!shareImage}>
                    <Loading />
                </If>
            </div>
        );
    }
}
